import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ConfigService, SessionService} from '@q9elements/ui-kit/common';
import {Marked, marked} from 'marked';

import {AiChatService} from './ai-chat.service';

@Injectable()
export class AiChatMarkdownService {
  private readonly marked = this.initMarkdownParser();

  constructor(
    private sanitizer: DomSanitizer,
    private aiChatService: AiChatService,
    private sessionService: SessionService
  ) {}

  public markdownToHtml(markdown: string) {
    const html = this.marked.parse(markdown);

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private initMarkdownParser() {
    const renderer = new marked.Renderer();

    renderer.heading = this.formatHeading;
    renderer.image = this.formatImage.bind(this);
    renderer.link = this.formatLink.bind(this);

    return new Marked({
      renderer,
      silent: true
    });
  }

  private formatHeading(text: string) {
    return `<p>${text}</p>`;
  }

  private formatImage(href: string, title: string, text: string) {
    let template = `<img src="${href}" alt="${title || text}"/>`;

    if (href.startsWith('file-')) {
      const signedUrl = [
        ConfigService.environment.API_ENDPOINT,
        'chat-ai',
        this.aiChatService.chatId(),
        'file',
        href,
        `content?team=${this.sessionService.teamId()}&index=${this.sessionService.teamIndex()}`
      ].join('/');

      template = template.replace(href, signedUrl);
    }

    return template;
  }

  private formatLink(href: string, title: string, text: string) {
    let template = `<a href="${href}" rel="noopener noreferrer">${title || text}</a>`;

    if (href.startsWith('file-')) {
      const signedUrl = [
        ConfigService.environment.API_ENDPOINT,
        'chat-ai',
        this.aiChatService.chatId(),
        'file',
        href,
        `content?team=${this.sessionService.teamId()}&index=${this.sessionService.teamIndex()}`
      ].join('/');

      template = template.replace(href, signedUrl);
    }

    return template;
  }
}
